export default {
    MODAL_TOGGLE: 'MODAL_TOGGLE',
    MODAL_OPEN: 'MODAL_OPEN'
}